import { useQuery } from '@tanstack/react-query';
import { fetchProfile } from '@features/profile/api';
import { useAuthStore } from '@shared/stores/authStore';

/**
 * Loads `GET /public/me` and keeps authStore names in sync for header / drawer.
 */
export function useMemberProfile() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated());

  return useQuery({
    queryKey: ['profile'],
    queryFn: fetchProfile,
    enabled: isAuthenticated,
    staleTime: 5 * 60_000,
  });
}
